import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { calculateRem } from '@uie/javascript-style-helpers';
import { ModalFooter as CoreModalFooter } from '@vds-core/modals';

var ModalFooter = function ModalFooter(props) {
  var children = props.children;
  return /*#__PURE__*/React.createElement(CoreModalFooter, _extends({}, props, {
    padding: undefined,
    noButtonPadding: false
  }), children);
};

export default ModalFooter;